var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeftCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7071 7.10711C11.0976 6.71658 11.0976 6.08342 10.7071 5.69289C10.3166 5.30237 9.68342 5.30237 9.29289 5.69289L10.7071 7.10711ZM6.4 10L5.69289 9.29289C5.30237 9.68342 5.30237 10.3166 5.69289 10.7071L6.4 10ZM9.29289 14.3071C9.68342 14.6976 10.3166 14.6976 10.7071 14.3071C11.0976 13.9166 11.0976 13.2834 10.7071 12.8929L9.29289 14.3071ZM13.6 11C14.1523 11 14.6 10.5523 14.6 10C14.6 9.44771 14.1523 9 13.6 9V11ZM18 10C18 14.4183 14.4183 18 10 18V20C15.5228 20 20 15.5228 20 10H18ZM10 18C5.58172 18 2 14.4183 2 10H0C0 15.5228 4.47715 20 10 20V18ZM2 10C2 5.58172 5.58172 2 10 2V0C4.47715 0 0 4.47715 0 10H2ZM10 2C14.4183 2 18 5.58172 18 10H20C20 4.47715 15.5228 0 10 0V2ZM9.29289 5.69289L5.69289 9.29289L7.10711 10.7071L10.7071 7.10711L9.29289 5.69289ZM5.69289 10.7071L9.29289 14.3071L10.7071 12.8929L7.10711 9.29289L5.69289 10.7071ZM13.6 9H6.4V11H13.6V9Z",
    fill: "#5268AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftCircle);
export default __webpack_public_path__ + "static/media/icon-Arrow-left-circle.7675df36cf8f4795872fd25ad111e3ef.svg";
export { ForwardRef as ReactComponent };